
import React, { useState, useEffect } from 'react';
import { apiUrl } from '../services/api';
import { Link } from 'react-router-dom';
import '../App.css';

const TABLES = [
  {
    name: 'trips',
    columns: ['trip_id', 'trip_name', 'created_at']
  },
  {
    name: 'activity_categories',
    columns: ['category_id', 'category_name', 'created_at']
  },
  {
    name: 'activity_types',
    columns: ['type_id', 'type_name', 'category_id', 'created_at']
  },
  {
    name: 'trip_activities',
    columns: ['activity_id', 'trip_id', 'destination_id', 'type_id', 'title', 'description', 'start_time', 'end_time', 'sort_order', 'created_at', 'updated_at']
  },
  {
    name: 'trip_destinations',
    columns: ['destination_id', 'trip_id', 'destination_name', 'start_date', 'end_date', 'created_at']
  }
];

function DatabaseView() {
  const [tableData, setTableData] = useState({});

  useEffect(() => {
    TABLES.forEach(async (table) => {
      try {
        let url = '';
        switch (table.name) {
          case 'trips':
            url = apiUrl('/api/trips');
            break;
          case 'activity_categories':
            url = apiUrl('/api/activity_categories');
            break;
          case 'activity_types':
            url = apiUrl('/api/activity_types');
            break;
          case 'trip_activities':
            url = apiUrl('/api/trip_activities');
            break;
          case 'trip_destinations':
            url = apiUrl('/api/trip_destinations');
            break;
          default:
            return;
        }
        const response = await fetch(url);
        const data = await response.json();
        setTableData(prev => ({ ...prev, [table.name]: data }));
      } catch (error) {
        setTableData(prev => ({ ...prev, [table.name]: [] }));
      }
    });
  }, []);

  const renderTable = (data, title, columns) => (
    <div key={title} className="tp-card" style={{ marginTop: 16 }}>
      <div className="tp-row" style={{ justifyContent: 'space-between' }}>
        <h2 className="tp-section__title" style={{ margin: 0 }}>{title}</h2>
        <span className="tp-pill">Rows: {data.length}</span>
      </div>
      <div style={{ overflowX: 'auto', marginTop: 12 }}>
        <table className="tp-table">
          <thead>
            <tr>
              {columns.map(col => <th key={col}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                {columns.map(col => <td key={col}>{row[col]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="App">
      <section className="tp-hero">
        <p className="tp-hero__kicker">Developer</p>
        <h1 className="tp-hero__title">Database View</h1>
        <p className="tp-hero__subtitle">Quick read-only view of tables for debugging.</p>
        <div className="tp-row" style={{ marginTop: 14 }}>
          <Link to="/">
            <button className="tp-btn--ghost">Back to Home</button>
          </Link>
        </div>
      </section>
      {TABLES.map(table => renderTable(
        tableData[table.name] || [],
        table.name.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
        table.columns
      ))}
    </div>
  );
}

export default DatabaseView;